import { render } from "./adminInventoryIntake.vue?vue&type=template&id=ad1f484a"
import script from "./adminInventoryIntake.vue?vue&type=script&lang=js"
export * from "./adminInventoryIntake.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__